import React from 'react';

import styles from '../../assets/styles/Onboarding/Onboarding.module.scss';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { mimaPayLogo } from '../../assets';

const OnboardLeft = props => {
	const isBelow450 = useMediaQuery({
		query: '(max-width: 450px)',
	});

	const navigate = useNavigate();

	const goToLanding = () => {
		navigate(constant.Routes.Home);
	};

	return (
		<div className={styles.left}>
			<img
				src={mimaPayLogo}
				className={styles.logo}
				onClick={goToLanding}
				alt="logo"
			/>
			{!isBelow450 && (
				<div>
					<h2 className={styles.left__h2}>
						Thank you for Signing up with Mima.
					</h2>
					<p className={styles.left__p}>
						You are just few clicks away from <br />a fully activated account.
					</p>
				</div>
			)}

			<div className={styles.crumbs}>
				<div className={props.crumbs1}></div>
				<div className={props.crumbs2}></div>
				<div className={props.crumbs3}></div>
			</div>
		</div>
	);
};

export default OnboardLeft;
